import laggy from 'api/middleware/laggy';
import useSWR, { SWRConfiguration, SWRResponse, unstable_serialize } from 'swr';
interface ProviderProps<DataType, QueryType = any> {
  fallbackData: DataType;
  query: QueryType;
  fetchFn: (query: QueryType) => Promise<DataType>;
  options?: SWRConfiguration;
}
/** useSWR wrapper with default options */
const useWrappedSWR = <DataType = any, ErrorType = any, QueryType = any>({
  query,
  fallbackData,
  fetchFn,
  options,
}: ProviderProps<DataType, QueryType>): SWRResponse<DataType, ErrorType> => {
  const { data, error, mutate, isValidating, isLoading } = useSWR<
    DataType,
    ErrorType
  >(
    [query],
    ([query]) => {
      return fetchFn(query);
    },
    {
      fallback: {
        [unstable_serialize([query])]: fallbackData,
        use: [laggy],
      },
      ...options,
    }
  );

  return { data, error, mutate, isValidating, isLoading };
};

export default useWrappedSWR;
